import { Injectable, inject, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

const DESKTOP_BREAKPOINT_PX = 768;

@Injectable({
  providedIn: 'root',
})
export class MobileMenuService {
  private readonly router = inject(Router);

  private isOpenSignal = signal<boolean>(false);
  isOpen = this.isOpenSignal.asReadonly();

  constructor() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => this.close());

    window.addEventListener('resize', () => {
      if (window.innerWidth >= DESKTOP_BREAKPOINT_PX && this.isOpen()) {
        this.close();
      }
    });
  }

  open(): void {
    this.isOpenSignal.set(true);
    document.body.style.overflow = 'hidden';
  }

  close(): void {
    this.isOpenSignal.set(false);
    document.body.style.overflow = '';
  }

  toggle(): void {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }
}
